import Vue from 'vue'
import Vuex from 'vuex'
import createVuexAlong from 'vuex-along'
// import user from './user'
import help from './help'
// import electronic from './electronic'
import documents from './documents'
// import userLog from './userLog'
import im from './im'
import equity from './equity'
import insuranceSelect from './insuranceSelect'
// import login from './login'
import qiyeshiming from './qiyeshiming'



import customerService from './modules/customerService'
import login from './modules/login'
import user from './modules/user'
import app from './modules/app'
import electronic from './modules/electronic'
import userLog from './modules/userLog'
import bannerList from './modules/list/bannerList'
import exposureList from './modules/list/exposureList'
import signInList from './modules/list/signInList'
import trendList from './modules/list/trendList'
import information from './modules/information'
import notice from './modules/notice'
import ElectronicDocumentsAdd from './ElectronicDocumentsAdd'
import hetongqianshu from './hetongqianshu'
import qiangzhi from './qiangzhi'
import fengxian from './fengxian'
import chaozhilibao from './chaozhilibao'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
	},
	mutations: {
	},
	actions: {
	},
	modules: {
		user,
		electronic,
		help,
		documents,
		userLog,
		im,
		equity,
		insuranceSelect,
		login,
		customerService,
		app,
		bannerList,
		exposureList,
		signInList,
		trendList,
		ElectronicDocumentsAdd,
		hetongqianshu,
		qiangzhi,
		fengxian,
		chaozhilibao,
		qiyeshiming,
		information,
		notice
	},
	// vuex 状态储存   文档-https://github.com/boenfu/vuex-along#readme
	plugins: [createVuexAlong({
		local: {
			list: ["user", "userLog", "equity", "insuranceSelect", "electronic",'ElectronicDocumentsAdd','qiangzhi','fengxian'],
		}
	})]
})
